import { render } from "./ChannelUser.vue?vue&type=template&id=52ff181d&scoped=true"
import script from "./ChannelUser.vue?vue&type=script&lang=js"
export * from "./ChannelUser.vue?vue&type=script&lang=js"

import "./ChannelUser.vue?vue&type=style&index=0&id=52ff181d&lang=scss&scoped=true"
import "./ChannelUser.vue?vue&type=style&index=1&id=52ff181d&lang=scss"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ff181d"]])

export default __exports__